<template>
  <ob-client-section type="comuneClient" label="Header_3.1">
  </ob-client-section>
</template>

<script>
import ClientSection from '@/components/ClientSection'

export default {
  name: 'comune-client',
  components: {
    'ob-client-section': ClientSection
  },
  data: () => ({
    type: 'comuneClient'
  }),
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
